declare namespace $ {

	type $mol_button_minor__title_shm_dashboard_admin_server_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_dashboard_admin_server_2 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server['refresh'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_server_3 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_server_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server['memory_usage'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_server_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_server_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server['memory_available'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_server_7 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_server_8 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server['process_memory'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_server_9 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_server_10 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server['disk_usage'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $shm_ba_summary_card__title_shm_dashboard_admin_server_11 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_ba_summary_card['title'] >
	>
	type $shm_ba_summary_card__value_shm_dashboard_admin_server_12 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server['storage_total'] >
		,
		ReturnType< $shm_ba_summary_card['value'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_dashboard_admin_server_15 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server['storage_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_dashboard_admin_server extends $mol_page {
		refresh( next?: any ): any
		Refresh( ): $mol_button_minor
		memory_usage( ): string
		Memory_usage( ): $shm_ba_summary_card
		memory_available( ): string
		Memory_available( ): $shm_ba_summary_card
		process_memory( ): string
		Process_memory( ): $shm_ba_summary_card
		disk_usage( ): string
		Disk_usage( ): $shm_ba_summary_card
		storage_total( ): string
		Storage_total( ): $shm_ba_summary_card
		Summary( ): $mol_view
		Storage_title( ): $mol_view
		storage_rows( ): readonly(any)[]
		Storage( ): $mol_list
		Storage_panel( ): $mol_view
		Details( ): $mol_view
		storage_name( id: any): string
		Storage_name( id: any): $mol_view
		storage_files( id: any): string
		Storage_files( id: any): $mol_view
		storage_size( id: any): string
		Storage_size( id: any): $mol_view
		title( ): string
		history( ): readonly(any)[]
		metric_history( ): readonly(any)[]
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Storage_row( id: any): $mol_view
		Empty( ): $mol_view
	}
	
	type $mol_view__sub_shm_dashboard_admin_server_charts_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_plot_line__title_shm_dashboard_admin_server_charts_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_shm_dashboard_admin_server_charts_3 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server_charts['disk_used_series'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_dot__series_y_shm_dashboard_admin_server_charts_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server_charts['disk_used_series'] >
		,
		ReturnType< $mol_plot_dot['series_y'] >
	>
	type $mol_plot_mark_cross__labels_shm_dashboard_admin_server_charts_5 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server_charts['history_labels'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_shm_dashboard_admin_server_charts_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $mol_chart__graphs_shm_dashboard_admin_server_charts_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_charts_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_plot_line__title_shm_dashboard_admin_server_charts_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_plot_line['title'] >
	>
	type $mol_plot_line__series_y_shm_dashboard_admin_server_charts_10 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server_charts['pb_storage_series'] >
		,
		ReturnType< $mol_plot_line['series_y'] >
	>
	type $mol_plot_dot__series_y_shm_dashboard_admin_server_charts_11 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server_charts['pb_storage_series'] >
		,
		ReturnType< $mol_plot_dot['series_y'] >
	>
	type $mol_plot_mark_cross__labels_shm_dashboard_admin_server_charts_12 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_server_charts['history_labels'] >
		,
		ReturnType< $mol_plot_mark_cross['labels'] >
	>
	type $mol_plot_mark_cross__graphs_shm_dashboard_admin_server_charts_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_plot_mark_cross['graphs'] >
	>
	type $mol_chart__graphs_shm_dashboard_admin_server_charts_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_chart['graphs'] >
	>
	type $mol_view__sub_shm_dashboard_admin_server_charts_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_dashboard_admin_server_charts extends $mol_page {
		Disk_chart_title( ): $mol_view
		disk_used_series( ): readonly(any)[]
		Disk_used_line( ): $mol_plot_line
		Disk_used_dots( ): $mol_plot_dot
		Disk_ruler( ): $mol_plot_ruler_vert
		history_labels( ): readonly(any)[]
		Disk_mark( ): $mol_plot_mark_cross
		Disk_chart( ): $mol_chart
		Pb_chart_title( ): $mol_view
		pb_storage_series( ): readonly(any)[]
		Pb_storage_line( ): $mol_plot_line
		Pb_storage_dots( ): $mol_plot_dot
		Pb_ruler( ): $mol_plot_ruler_vert
		Pb_mark( ): $mol_plot_mark_cross
		Pb_chart( ): $mol_chart
		Charts( ): $mol_view
		title( ): string
		history( ): readonly(any)[]
		metric_history( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=server.view.tree.d.ts.map